// item 327 — THE money formatters (replaces ~18 per-file `const money = ...` clones).
// All of them respect STEALTH MODE: one toggle (AppearanceProvider) masks every figure
// app-wide for demos / client conversations. The flag lives here at module level so the
// formatters stay plain functions; AppearanceProvider keeps it in sync and its context
// update re-renders every consumer, so a toggle repaints instantly.

let stealthOn = false;

/** AppearanceProvider is the ONLY caller — components toggle via useAppearance(). */
export const syncStealthFlag = (v: boolean): void => { stealthOn = v; };

export const isStealth = (): boolean => stealthOn;

const MASK = '•••';

/** "$1,234.56" — the standard money treatment (grids, stats, ledgers) */
export const money = (n?: number | null): string => (
  stealthOn ? MASK : (n ?? 0).toLocaleString(undefined, { style: 'currency', currency: 'USD' })
);

/** "$1,235" — whole-dollar treatment (reports, dashboard tiles) */
export const moneyRounded = (n?: number | null): string => (
  stealthOn ? MASK : `$${Math.round(n ?? 0).toLocaleString()}`
);

/** "$1.2m / $42k / $920" — the slim KPI-strip treatment */
export const compactMoney = (n?: number | null): string => {
  if (stealthOn) return MASK;
  const v = n ?? 0;
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}m`;
  if (abs >= 1_000) return `$${Math.round(v / 1_000)}k`;
  return `$${Math.round(v)}`;
};
